import { render, staticRenderFns } from "./SkyboxInfo.vue?vue&type=template&id=468e0fe3"
import script from "./SkyboxInfo.vue?vue&type=script&lang=js"
export * from "./SkyboxInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports